import { Injectable } from '@angular/core';
import { ConfigService } from 'app/config';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class HelperService {
  scripts = [
    {name: 'g-analytics', path: 'assets/script/g-analytics.js', load: false},
    // {name: 'pathscript', path: 'https://www.googletagmanager.com/gtag/js?id=G-ZDNYNCW51Y', load: false}
  ];
  //  scripts: any;
  googleAnalyticsTrackingId: any;
  currentMediaElement: HTMLMediaElement;
  public mainScroll$ = new BehaviorSubject<any>(false);
  mainScrollOb = this.mainScroll$.asObservable();

  public sideNav$ = new BehaviorSubject<any>(false);
  sideNavOb = this.sideNav$.asObservable();

  public importData$ = new BehaviorSubject<any>(false);
  importDataOb = this.importData$.asObservable();

  public importWordJumbleData$ = new BehaviorSubject<any>(false);
  importWordJumbleDataOb = this.importData$.asObservable();

  public importMatchGameData$ = new BehaviorSubject<any>(false);
  importMatchGameDataOb = this.importData$.asObservable();

  public appLibraryData$ = new BehaviorSubject<any>(false);
  appLibraryDataOb = this.appLibraryData$.asObservable();

  public selectedAppDataa$ = new BehaviorSubject<any>(false);
  selectedAppDataaOb = this.selectedAppDataa$.asObservable();

  public selectedCompletedAppDataa$ = new BehaviorSubject<any>(false);
  selectedCompletedAppDataaOb = this.selectedCompletedAppDataa$.asObservable();

  public multigameData$ = new BehaviorSubject<any>(false);
  multigameDataOb = this.multigameData$.asObservable();

  public userData$ = new BehaviorSubject<any>(false);
  userDataOb = this.userData$.asObservable();

  public toggleStatusData$ = new BehaviorSubject<any>(false);
  toggleStatusOb = this.toggleStatusData$.asObservable();

public selectCount$ = new BehaviorSubject<any>(1);
selectCountOb = this.selectCount$.asObservable();

public selectCountValue$ = new BehaviorSubject<any>(0);
selectCountValue = this.selectCountValue$.asObservable();

public saved$ = new BehaviorSubject<any>(false);
saved = this.saved$.asObservable();

public savebtn$ = new BehaviorSubject<any>(false);
savebtn = this.savebtn$.asObservable(); 

public activeMemberTab$ = new BehaviorSubject<number>(0);
activeMemberTabOb = this.activeMemberTab$.asObservable();

public activeUserRole$ = new BehaviorSubject<string>('');
activeUserRoleOb = this.activeUserRole$.asObservable(); 

public activeUserDetails$ = new BehaviorSubject<any>({});
activeUserDetailsOb = this.activeUserDetails$.asObservable();

  debounceStorage: any;
  debounce(callback) {
    if (this.debounceStorage) {
      clearTimeout(this.debounceStorage);
    }
    this.debounceStorage = setTimeout( () => {
      callback()
    });
  }
  constructor( private configService: ConfigService) {
    this.configService.getConfigNew().subscribe(config => {
      this.googleAnalyticsTrackingId = config.googleAnalytics.trackingId;
     
      let Obj =  {name: 'pathscript', path: 'https://www.googletagmanager.com/gtag/js?id=' +  this.googleAnalyticsTrackingId, load: false};
      this.scripts.push(Obj);
      // this.scripts = [
      //   {name: 'g-analytics', path: 'assets/script/g-analytics.js', load: false},
      //   {name: 'pathscript', path: 'https://www.googletagmanager.com/gtag/js?id={{this.googleAnalyticsTrackingId}}', load: false}
      // ];

    });
   }

  loadScript(name) {
    if(this.scripts){
    const script = this.scripts.filter( (next) => {
      if (next.name === name) {
        next.load = true;
        return next;
      }

    })[0];
    if (script) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = script.path;
      s.className = script.name;
      document.head.appendChild(s);
    }
  }

  }

  setAppData(selectedAppData){
    localStorage.setItem("selectedApp", JSON.stringify(selectedAppData));
    this.selectedAppDataa$.next(selectedAppData);
  }

  setCompletedAppData(selectedAppData){
    this.selectedCompletedAppDataa$.next(selectedAppData);
  }

  setDetailsFromURL(details: any) {
    localStorage.setItem('UserDetailsDataFromUrl', JSON.stringify(details));
  }

  removeDetailsFromURL() {
    localStorage.removeItem('UserDetailsDataFromUrl');
  }

  getIsMobileDevice(): boolean {
    let data = JSON.parse(localStorage.getItem('UserDetailsDataFromUrl'));
    return data && data.device?.toLowerCase() == 'mobile';
  }

  getMobileLoginData(): any {
    let data = JSON.parse(localStorage.getItem('UserDetailsDataFromUrl'));
    return data;
  } 
}
